/**
 * The site's navigation, in one place.
 *
 * The floating pill renders this at every width — the owner asked for the
 * Instagram-style oval bar on desktop as well as on phones, and it is the site's
 * only navigation. A reference mock later showed a desktop top bar; the owner's
 * typed instruction wins over a picture.
 *
 * Keeping the entries here is what makes adding a section a one-line change
 * rather than an edit in two places that drift.
 */
export interface NavItem {
  to: string;
  /** The accessible name at every width, and the visible one from `lg`. */
  label: string;
  /** Shown between `sm` and `lg`, where the full labels will not fit. */
  shortLabel: string;
  /**
   * Matches only the exact path. True for the root entry, which would otherwise
   * match every route.
   */
  end: boolean;
  /**
   * A wordmark to draw INSTEAD of the icon and the label.
   *
   * For a partner whose identity is the logo itself. It costs the pair of
   * filled/outlined glyphs the other entries use to signal the active state, so
   * that entry falls back to the shared background tint plus a brightness
   * change — see BottomNav.
   */
  logo?: { src: string; alt: string };
}

export const navItems: NavItem[] = [
  { to: '/', label: 'Anasayfa', shortLabel: 'Ana', end: true },
  {
    to: '/moon',
    label: 'Moon',
    shortLabel: 'Moon',
    end: false,
    logo: { src: '/moon-logo.svg', alt: 'Moon' },
  },
  { to: '/trusted-sites', label: 'Güvenilir Siteler', shortLabel: 'Siteler', end: false },
  { to: '/wager-races', label: 'Çevrim Yarışmaları', shortLabel: 'Çevrim', end: false },
  { to: '/ticket-events', label: 'Bilet Etkinlikleri', shortLabel: 'Bilet', end: false },
  { to: '/milestone-rewards', label: 'Milestone', shortLabel: 'Milestone', end: false },
  { to: '/market', label: 'Market', shortLabel: 'Market', end: false },
  { to: '/geecoin', label: 'GeeCoin', shortLabel: 'GeeCoin', end: false },
  { to: '/promotions', label: 'Promosyonlar', shortLabel: 'Promo', end: false },
];
